import { Profile } from '~/helpers/userProfile';

// Diel e o Admin de Conta daquele cliente gerenciam o Painel completo: criam, excluem e editam
// todos os cadastros. Fonte única da regra no Painel — não recalcular nos componentes.
// O Admin de Conta é decidido pelo perfil no próprio cliente ([ADMC], ou [ADMCAD] nos subclientes
// da conta), como no API-Server: isAdminConta vale para a sessão inteira (basta [ADMC] em qualquer cliente).
export function canManageWholePanel(profile: Profile, clientId: number | string | null | undefined): boolean {
  if (profile.manageAllClients) return true;
  if (clientId == null) return false;
  const permsOnClient = profile.permissions.PER_CLIENT?.find((x) => x.clientId === Number(clientId));
  return !!permsOnClient?.p.some((x) => x === '[ADMC]' || x === '[ADMCAD]');
}

// O modo restrito vale só para o Admin de cliente que recebeu a opção de editar cadastros
// naquele cliente; quem gerencia o Painel completo nunca fica restrito.
export function isRegistryEditRestricted(profile: Profile, clientId: number | string | null | undefined): boolean {
  if (clientId == null || canManageWholePanel(profile, clientId)) return false;
  return profile.adminClientEdit?.CLIENT_MANAGE.includes(Number(clientId)) ?? false;
}

// Quem pode editar cadastros no Painel: o Painel completo ou o modo restrito.
export function canEditRegistry(profile: Profile, clientId: number | string | null | undefined): boolean {
  return canManageWholePanel(profile, clientId) || isRegistryEditRestricted(profile, clientId);
}
